import { FULFILLMENT } from "./fulfillment";
import { PRODUCT_MANAGEMENT } from "./productManagement";

export const NAVIGATION = [
    ...FULFILLMENT,
    ...PRODUCT_MANAGEMENT
];